export enum ActivityType {
  AVAILABILITY = 'AVAILABILITY',
  WORK = 'WORK',
  DRIVING = 'DRIVING',
  REST = 'REST',
  UNKNOWN = 'UNKNOWN',
}
